import { Action } from '@ngrx/store';

export const VISUALIZAR_DN = '[NIS] VizualizarDN';
export const OCULTAR_DN = '[NIS] OcultarDN';


export class VisualizarDNAction implements Action {
  readonly type = VISUALIZAR_DN;
  constructor(public Nis:string) {}
}
export class OcultarDNAction implements Action {
  readonly type = OCULTAR_DN;
  constructor() {}
}

export type PanelDNActions =
    | VisualizarDNAction
    | OcultarDNAction;